module.exports = {
	"rounds": [
		{
			"text1": "Welcome",
			"text2": "Welcome to Intro to Business Game!",
			"text3": ""
		},
		{
			"text1": "Welcome to Round 2!",
			"text2": "Welcome to Round 2!",
			"text3": ""
		},
		{
			"text1": "Welcome to Round 3!",
			"text2": "Welcome to Round 3!",
			"text3": ""
		},
		{
			"text1": "Welcome to Round 4!",
			"text2": "Welcome to Round 4!",
			"text3": ""
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/data/onboarding/welcome.json
// module id = 1968
// module chunks = 0